import {PackingStyleField} from "../molecules/PackingStyleField";
import {ItemCategoryField} from "../molecules/ItemCategoryField";
import {ItemNameField} from "../molecules/ItemNameField";
import {ItemSubCategoryField} from "../molecules/ItemSubCategoryField";
import {SeasonTagField} from "../molecules/SeasonTagField";
import {CookingStyleField} from "../molecules/CookingStyleField";
import {SearchItemOtherOptions} from "../molecules/SearchItemOtherOptions";
import FormButton from "../atoms/FormButton";
import {Form} from "react-final-form";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useRouter} from "next/router";
import {BasicInfoField} from "../organisms/BasicInfoField";
import {ExamResultField} from "../organisms/ExamResultField";
import {setBloodTest, setSearchType} from "../../../stores/slices/items/itemSearchOption";
import {toggleDrawer} from "../../../stores/slices/commons/drawer";
import {Divider} from "@material-ui/core";
import {Box, Grid} from "@mui/material";
import colorPalette from "../../../styles/theme/colorPalette";

export const ItemSearchBloodTestForm = (props) => {
  const { searchType } = props
  const dispatch = useDispatch()
  const router = useRouter()

  const itemSearchOptionState = useSelector((state) => state.itemSearchOption)

  const submitSearchBloodTestParams = (value) => {
    dispatch(setSearchType(searchType))
    dispatch(setBloodTest(value))
    dispatch(toggleDrawer({openFlg: false, key: 'search'}))

    const pathname = '/items/'
    router.push(pathname)
  }

  const initialValues = {
    ...itemSearchOptionState.bloodTest
  }

  return (
      <Form
          onSubmit={submitSearchBloodTestParams}
          initialValues={initialValues}
          render={({ handleSubmit, form, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit} >
                <Grid container justifyContent={'center'}>
                  <Grid item><BasicInfoField/></Grid>
                </Grid>
                  <Divider css={{margin: '16px 0'}}/>
                <Grid container flexDirection={'column'} alignItems={'center'}>
                  <Grid item><ExamResultField/></Grid>
                  <Grid item css={{minWidth:'240px'}}>
                    <FormButton
                        text_first={"検索"}
                        submitting={submitting}
                        style={{margin:'2rem 0',backgroundColor: colorPalette.primary, color: 'white'}}
                    />
                  </Grid>
                </Grid>
              </form>
          )}
      />
  )
}
